function nFormatter(num, digits) {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    if (num >= 0) {
      var item = lookup.slice().reverse().find(function(item) {
        return num >= item.value-1;
      });
      return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    }
    else {
       var item = lookup.slice().reverse().find(function(item) {
        return -num >= item.value-1;
      });
      return item ? "-" + (-num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    };
 };
